import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { AppContext } from "./utils/stateHandlers/contexts";
import { constants } from "./utils";
import Layout from "./components/Layout/Layout";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { Home, Product, Products } from "./components/pages";
import CareersHome from "./components/pages/careers/CareersHome";
import CertDiamondSearchLanding from "./components/diamonds/CertDiamondSearchLanding";
import BlankDiamondDetails from "./components/diamonds/BlankDiamondDetails";
import BuildARing from "./components/products/productDetails/BuildARing";
import baseMuiTheme from "./assets/styles/theme";
import { QueryParamProvider } from "use-query-params";
import Login from "./components/user/Login";
import Articles from "./components/pages/articles/Articles";
import SingleArticle from "./components/pages/articles/SingleArticle";
import Faq from "./components/pages/static/Faq";
import StaticLanding from "./components/pages/static/StaticLanding";
import { storage } from "./utils";
import StaticSubLanding from "./components/pages/static/StaticSubLanding";
import UpdatePassword from "./components/user/UpdatePassword";
import LinksPage from "./components/pages/static/LinksPage";
import MeleeDiamondSearchLanding from "./components/diamonds/MeleeDiamondSearchLanding";
import CertDiamondDetails from "./components/diamonds/CertDiamondDetails";
import _ from "lodash";
import UserProfile from "./components/user/UserProfile";
import Cart from "./components/user/Cart";
import ForgotPassword from "./components/user/ForgotPassword";
import AccordionStaticLanding from "./components/pages/static/AccordionStaticLanding";
import AuctionsPage from "./components/diamonds/components/AuctionsPage";
import StonePurchaseService from "./components/diamonds/components/StonePurchaseService";
import CastingCalculator from "./components/pages/forms/CastingCalculator";
import RefiningShippingForm from "./components/pages/forms/RefiningShippingForm";
import RefiningCalculator from "./components/pages/forms/RefiningCalculator";
import FDJLanding from "./components/diamonds/components/FDJLanding";
import Checkout from "./components/user/Checkout";
import { Toaster } from "react-hot-toast";
import AuctionSignUp from "./components/diamonds/components/AuctionSignUp";
import AuctionSignUp2 from "./components/diamonds/components/AuctionSignUp2";
import AuctionSignUp3 from "./components/diamonds/components/AuctionSignUp3";
import CreateAccount from "./components/user/CreateAccount";
import ContactUs from "./components/pages/forms/ContactUs";
import SitewideSearch from "./components/pages/SitewideSearch";

export default function App() {
  const nowTime = () => new Date().getTime();
  const tokenFromStorage = storage.getStorageItem("authToken");
  const parsedUser = tokenFromStorage
    ? JSON.parse(storage.getStorageItem("currentUser"))
    : null;
  const cartIdFromStorage = storage.getStorageItem("cartId");
  const [authToken, setAuthToken] = useState(tokenFromStorage);
  const [currentUser, setCurrentUser] = useState(parsedUser);
  const [showFooter, setShowFooter] = useState(true);
  const [showHeader, setShowHeader] = useState(true);
  const [showCustomMetalMarkets, setShowCustomMetalMarkets] = useState(false);
  const [showMetalMarkets, setShowMetalMarkets] = useState(false);

  ReactGA.initialize(constants.GOOGLE_ANALYTICS_MEASUREMENT_ID);

  function isAuthenticated() {
    return authToken !== null;
  }

  function signOut() {
    storage.removeStorageItem("authToken");
    storage.removeStorageItem("currentUser");
    storage.removeStorageItem("sessionExpiry");
    storage.clearSessionStorage();
    setAuthToken(null);
    setCurrentUser(parsedUser);
  }

  const user = {
    currentUser: currentUser,
    signIn: (newUser, token) => {
      if (token) {
        storage.setStorageItem("authToken", token);
        setAuthToken(token);
      }
      storage.setStorageItem("currentUser", JSON.stringify(newUser.Login));
      cartIdFromStorage
        ? storage.setStorageItem("cartId", cartIdFromStorage)
        : storage.setStorageItem("cartId", newUser.CartId);
      storage.setStorageItem(
        "sessionExpiry",
        JSON.stringify(nowTime() + 60480000)
      );
      setCurrentUser(newUser);
    },
    signOut: signOut,
  };

  const AuthRoute = ({ component: Component, ...extraProps }) => {
    const currentLocation = useLocation();
    return (
      <Route
        {...extraProps}
        render={(props) => {
          const combinedProps = Object.assign(props, extraProps);
          if (authToken === null) {
            //setPreviousPage(props.location);
            return (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { sendTo: currentLocation.pathname },
                }}
              />
            );
          }
          return <Component {...combinedProps} />;
        }}
      />
    );
  };

  const LoginRoute = ({ component: Component, ...extraProps }) => {
    return (
      <Route
        {...extraProps}
        render={(props) => {
          const combinedProps = Object.assign(props, extraProps);
          if (isAuthenticated()) {
            //I want this redirect to return the the previous page. React-router history?
            const sendTo = props.location.state
              ? props.location.state.sendTo
              : null;
            const mtoConfiguratorProduct = props.location.state
              ? props.location.state.mtoConfiguratorProduct
              : false;
            if (sendTo) {
              return (
                <Redirect
                  to={{
                    pathname: `${sendTo}`,
                    state: { mtoConfiguratorProduct: mtoConfiguratorProduct },
                  }}
                />
              );
            }
            return <Redirect to="/" />;
          }
          if (
            (_.startsWith(combinedProps.path, "/update-password") ||
              _.startsWith(combinedProps.path, "/forgot-password")) &&
            Component
          ) {
            return <Component {...combinedProps} />;
          }
          return <Login {...combinedProps} />;
        }}
      />
    );
  };

  const NoPriceIfLoggedOutRoute = ({ component: Component, ...extraProps }) => {
    return (
      <Route
        {...extraProps}
        render={(props) => {
          const combinedProps = Object.assign(props, extraProps);
          if (authToken === null) {
          }
          return <Component {...combinedProps} />;
        }}
      />
    );
  };

  useEffect(() => {
    if (storage.getStorageItem("sessionExpiry")) {
      const expiry = JSON.parse(storage.getStorageItem("sessionExpiry"));
      if (nowTime() > expiry) {
        user.signOut();
      } else {
        storage.setStorageItem(
          "sessionExpiry",
          JSON.stringify(nowTime() + 60480000)
        );
      }
    } else {
      user.signOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppContext.Provider
      value={{
        showFooter,
        setShowFooter,
        showHeader,
        setShowHeader,
        showCustomMetalMarkets,
        setShowCustomMetalMarkets,
        user,
        showMetalMarkets,
        setShowMetalMarkets,
        authToken,
      }}
    >
      <QueryParamProvider ReactRouterRoute={Route}>
        {/* <SessionConsumer /> */}
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={baseMuiTheme}>
            <Toaster />
            <Layout loggedIn={tokenFromStorage}>
              <Switch>
                {/* Authentication and Password Routes */}
                <LoginRoute exact path="/login" component={Login} />
                <Route
                  exact
                  path="/update-password"
                  component={UpdatePassword}
                />
                <Route
                  exact
                  path="/forgot-password"
                  component={ForgotPassword}
                />

                {/* Routes that do not need a log in. Information, body copy pages, articles, etc. */}
                <Route path="/" exact component={Home} />
                <Route
                  path="/search/:SearchTerm"
                  exact
                  component={SitewideSearch}
                />
                <Route path="/create-account" exact component={CreateAccount} />
                <Route exact path="/careers" component={CareersHome} />
                <Route
                  exact
                  path="/myauction-log-in"
                  component={AuctionsPage}
                />
                <Route
                  exact
                  path="/auction-signup2"
                  component={AuctionSignUp2}
                />
                <Route
                  exact
                  path="/auction-signup3"
                  component={AuctionSignUp3}
                />
                <Route
                  exact
                  path="/harmony-auction-signup"
                  component={AuctionSignUp}
                />
                <Route
                  exact
                  path="/stone-purchasing-service"
                  component={StonePurchaseService}
                />
                <Route
                  exact
                  path="/finished-diamond-jewelry"
                  component={FDJLanding}
                />
                <Route
                  exact
                  path="/landing/:PageType"
                  component={StaticLanding}
                />
                <Route
                  exact
                  path="/accordion-landing/:PageType"
                  component={AccordionStaticLanding}
                />
                <Route
                  exact
                  path="/sub-landing/:PageType"
                  component={StaticSubLanding}
                />
                <Route exact path="/links/:PageType" component={LinksPage} />
                <Route exact path="/contact" component={ContactUs} />
                <Route
                  exact
                  path="/refining-calculator"
                  component={RefiningCalculator}
                />
                <Route
                  exact
                  path="/refining-shipping-form"
                  component={RefiningShippingForm}
                />
                <Route exact path="/faq/:PageType" component={Faq} />
                <Route
                  exact
                  path="/technicalarticles/:ArticleId"
                  component={SingleArticle}
                />
                <Route exact path="/technicalarticles" component={Articles} />
                <Route
                  exact
                  path="/blankdiamond/:HooverStockId"
                  component={BlankDiamondDetails}
                />
                <Route exact path="/products/:Category" component={Products} />

                {/* Diamond Routes are different - you can search diamonds without being logged in but cannot see any prices or add to cart. */}
                <NoPriceIfLoggedOutRoute
                  exact
                  path="/diamonds/"
                  component={CertDiamondSearchLanding}
                />
                <NoPriceIfLoggedOutRoute
                  exact
                  path="/melee-diamonds/"
                  component={MeleeDiamondSearchLanding}
                />
                <NoPriceIfLoggedOutRoute
                  exact
                  path="/diamond/:HooverStockId"
                  component={CertDiamondDetails}
                />

                {/* You must be logged in to the site to see these pages. */}
                <NoPriceIfLoggedOutRoute
                  exact
                  path="/product/:ProductStyleCode/:ProductStyleCodeSecondPart/:ProductStyleCodeThirdPart"
                  component={Product}
                />
                <NoPriceIfLoggedOutRoute
                  exact
                  path="/product/:ProductStyleCode/:ProductStyleCodeSecondPart"
                  component={Product}
                />
                <NoPriceIfLoggedOutRoute
                  exact
                  path="/product/:ProductStyleCode"
                  component={Product}
                />
                {/* <AuthRoute
                  exact
                  path="/product-new/:ProductStyleCode"
                  component={ProductDetailPage}
                /> */}
                <AuthRoute
                  exact
                  path="/ring/build/:product"
                  component={BuildARing}
                />
                <AuthRoute
                  exact
                  path="/casting-calculator"
                  component={CastingCalculator}
                />
                <AuthRoute exact path="/ring/build" component={BuildARing} />
                <AuthRoute exact path="/account" component={UserProfile} />
                <AuthRoute exact path="/cart" component={Cart} />
                <AuthRoute exact path="/checkout" component={Checkout} />
              </Switch>
            </Layout>
          </ThemeProvider>
        </StyledEngineProvider>
      </QueryParamProvider>
    </AppContext.Provider>
  );
}
